import AES from 'crypto-js/aes'
import MD5 from 'crypto-js/md5'
import Utf8 from 'crypto-js/enc-utf8'

const platformName = 'moFang'
const key = '='
String.prototype.replaceAll = function(oldStr, newStr) { //将oldStr替换成newStr
  const reg = new RegExp(oldStr, 'g') //创建正则RegExp对象
  return this.replace(reg, newStr)
}

function getKeyNumber(key) {
  const len = key.length
  return Math.floor(Math.random() * (len - 1) + 10)
}

function encrypt(data) {
  const secretKey = MD5(platformName + new Date().getTime()).toString()
  let keyNumber = getKeyNumber(secretKey)
  const userSecretKey = secretKey.substr(0, keyNumber)
  const ciphertext = AES.encrypt(data + '', userSecretKey).toString()
  return keyNumber + key + secretKey + ciphertext
}

function decrypt(text) {
  text = text.replaceAll(' ', '+') //浏览器获会把加号变，空格，这里需要转回来
  const secretKey = MD5(platformName + new Date().getTime()).toString()
  if (text && text.length > secretKey.length + 1) {
    let keyIndex = text.indexOf(key)
    const num = text.substr(0, keyIndex)
    const oldSecretKey = text.substr(keyIndex + 1, secretKey.length)
    const endIndex = (num + key + oldSecretKey).length
    const ciphertext = text.substr(endIndex)
    const userSecretKey = oldSecretKey.substr(0, num)
    const bytes = AES.decrypt(ciphertext, userSecretKey)
    return bytes.toString(Utf8)
  }
}

//自定义辅助加密工具
export default class UserHelper {
  static encryptToken(token) {
    return encrypt(token)
  }

  static decryptToken(data) {
    return decrypt(data)
  }

  static getPasswordEncrypt(password) {
    return MD5(password + 'akfokn911AUo').toString()
  }

  static getCloudMD5Code(merchantId, platformId) {
    return MD5(merchantId + platformId + 'yunCang').toString()
  }

  static md5(paramsStr) {
    return MD5(paramsStr).toString()
  }
}